import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isUserLoggedIn } from "../Utils/helper";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";

const ProtectedRoutes = (props) => {

    const auth = isUserLoggedIn();

    return auth ? <>
        <Header />
        <Outlet />
        <Footer />

    </> : <Navigate to="/login" />;
};

export default ProtectedRoutes;
